import React from 'react'
import Grid from '@mui/material/Grid';

const Authentication = () => {

    return (
        <Grid item xs={8}>
            This is authentication page.
        </Grid>
    )
}

export default Authentication
